import { FC, useState } from "react";

import { MenuItems } from "services/app/types";

import SiteMapColumn from "./SiteMapColumn";

interface FooterTopProps {
  menuItems: MenuItems;
}

const SiteMap: FC<FooterTopProps> = ({ menuItems }) => {
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false);
  const handleToggleMobileMenu = () => {
    setIsMobileMenuVisible(v => !v);
  };

  return (
    <>
      <div
        className={`-mobile-heading ${isMobileMenuVisible ? "-open" : ""}`}
        onClick={handleToggleMobileMenu}
      >
        <h4 className="text -footer">Menu</h4>
        <div className="plus">
          <span></span>
        </div>
      </div>
      <div
        className={`-footer-links ${
          isMobileMenuVisible ? "footer-opened" : "footer-closed"
        }`}
      >
        <SiteMapColumn menuItems={menuItems.footer_col_1 || []} />
        <SiteMapColumn menuItems={menuItems.footer_col_2 || []} />
        <SiteMapColumn menuItems={menuItems.footer_col_3 || []} />
      </div>
    </>
  );
};

export default SiteMap;
